import axios from 'axios';

const api = axios.create({
  baseURL: '/api/blog',
  headers: { 'Content-Type': 'application/json' },
});

export default api;
